import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  width: 100%;
`;

const Title = styled.h3`
  color: #566072;
  font-size: 0.875rem;
  font-weight: 400;
  margin-top: 0;
  margin-left: 1rem;
`;

const ScrollableText = styled.div`
  border: 2px solid #bdcad2;
  margin: 0 1rem 1rem 1rem;
  padding: 0.7rem;
  height: 10rem;
  color: #566072;
  font-size: 0.75rem;
  letter-spacing: 0.03rem;
  line-height: 1.1rem;
  overflow-y: scroll;
  overflow-x: auto;
`;

interface Props {
  details: string;
}

function ErrorDetails(props: Props) {
  return (
    <Wrapper>
      <Title>Error Details</Title>
      <ScrollableText>{props.details}</ScrollableText>
    </Wrapper>
  );
}

export default ErrorDetails;
